export default class Income {
    constructor(_id, _Income, _IncomeType, _PayFrequency) {
      this.id = _id;
      this.Income = _Income;
      this.IncomeType = _IncomeType;
      this.PayFrequency = _PayFrequency;
      this.PayStub = [];
      this.PayStub2 = [];
      this.PayStub3 = [];
      this.PayStub4 = [];
      this.ProofOfIncome = [];
    }
  }